import React, { ReactElement } from 'react';
import cn from 'classnames';
import IconProps from '../IconProps';
import '../design-catalogue-icons.scss';

export default function IconLeft({ className, ariaHidden = false }: IconProps): ReactElement {
    return <div className={cn('icon-left', className)} aria-hidden={ariaHidden} />;
}
